import axios from 'axios';

export default {
  getAll() {
    return axios.get('/restaurant/areas');
  },

  getById(id) {
    return axios.get(`/restaurant/areas/${id}`);
  },

  create(data) {
    return axios.post('/restaurant/areas', data);
  },

  update(id, data) {
    return axios.put(`/restaurant/areas/${id}`, data);
  },

  delete(id) {
    return axios.delete(`/restaurant/areas/${id}`);
  }
}
